import { DEFAULT_LOCALE, type Locale } from '@ghostscreen/contracts';
import { i18n } from './i18n';

/** Non-English translations become separate chunks, downloaded only when chosen. */
const loaders = import.meta.glob<Record<string, unknown>>(
  ['./locales/*/*.json', '!./locales/en/*.json'],
  { import: 'default' },
);

const LOADER_PATH = /^\.\/locales\/([^/]+)\/([^/]+)\.json$/;

export async function loadLocaleResources(locale: Locale): Promise<void> {
  if (locale === DEFAULT_LOCALE || i18n.hasResourceBundle(locale, 'common')) return;

  await Promise.all(
    Object.entries(loaders).map(async ([path, load]) => {
      const match = LOADER_PATH.exec(path);
      if (!match || match[1] !== locale) return;
      i18n.addResourceBundle(locale, match[2]!, await load(), true, true);
    }),
  );
}
